import {Box, styled} from '@mui/material'

export const StyledInfoBanner = styled('div')(({theme}) => ({
  backgroundColor: theme.palette.info.light,
  color: theme.palette.hpAccentTeal,
  display: 'flex',
  alignItems: 'center',
  minHeight: '40px',
  padding: `${theme.spacing(0)} ${theme.spacing(1)}`
}))

export const StyledSpaceBox = styled(Box)(() => ({
  height: '120px'
}))
